export default {
  init() {
    // JavaScript to be fired on the resources page

    $(".vc_gitem-post-data-source-resource_type:contains('Imagine Reports')").addClass("text-orange");
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/resources.js